import File from './file';
import Camera from './camera';

export default {
  File,
  Camera,
};
